import { jsx as u } from "react/jsx-runtime";
import { useTranslationContext as i } from "../../../contexts/TranslationProvider/context.js";
import { useWatcher as l } from "../../../hooks/watcher/index.js";
import { getTimeAgoString as m } from "../../../services/time/index.js";
function s({
  publishedDate: t,
  className: r
}) {
  const { locale: n } = i(), e = () => t ? m(new Date(t), n || "") : null, o = l({
    input: t && new Date(t) || null,
    outputHandler: e,
    updateInterval: 6e4
  });
  return t ? /* @__PURE__ */ u("span", { className: r, children: o }) : null;
}
export {
  s as DealPublishedDate
};
